import * as React from "react";
import { Icon } from "@utdanningsdirektoratet/icon";
import { Tooltip } from "@utdanningsdirektoratet/tooltip";
import { getSupressAttributes } from "@utdanningsdirektoratet/utils/attribute";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { capitalize } from "@utdanningsdirektoratet/utils/string";
import { TagType } from "./types";
import styles from "./TagsInput.module.less";

type TagProps = {
  onDelete: () => void;
  tag: TagType;
  readOnly?: boolean;
  fullwidth?: boolean;
  error?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLSpanElement>) => void;
  sensitive?: boolean;
  message?: React.ReactNode | string;
  color: "none" | "offwhite";
};

const Tag: React.FC<TagProps> = ({
  tag,
  error,
  onDelete,
  readOnly,
  fullwidth,
  message,
  sensitive,
  onKeyDown,
  color,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>): void => {
    if (error && (event.key === "Enter" || event.key === "Backspace")) {
      onDelete();
      return;
    }

    if (readOnly || error) return;

    if (onKeyDown) {
      onKeyDown(event);
    }

    if (event.key === "Backspace") {
      onDelete();
    }
  };

  const handleOnClick = (): void => {
    if (error) {
      onDelete();
    }
  };

  const tagClass = cls({
    [styles.tagsInputTagsItem]: true,
    [styles.tagsInputTagsItemFullwidth]: fullwidth,
    [styles.tagsInputTagsItemReadonly]: readOnly,
    [styles.tagsInputTagsItemError]: error,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    [styles[`tagsInputTagsItem${capitalize(color)}`]]: color,
  });
  const tooltipClass = cls({
    [styles.tagsInputTagsItemTooltipInline]: !fullwidth,
    [styles.tagsInputTagsItemTooltipBlock]: fullwidth,
  });
  return (
    <Tooltip className={tooltipClass} message={message} disabled={!error} alert>
      <span
        {...getSupressAttributes(sensitive)}
        className={tagClass}
        role="button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
        onClick={handleOnClick}
      >
        {!readOnly && !error ? (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <span className={styles.tagsInputTagsItemRemove} onClick={onDelete}>
            <Icon
              className={styles.tagsInputTagsItemRemoveIcon}
              icon="circle cross"
            />
          </span>
        ) : null}
        {tag.title}
        {tag.description ? (
          <div className={styles.tagsInputTagsItemDescription}>
            {tag.description}
          </div>
        ) : null}
      </span>
    </Tooltip>
  );
};

export default Tag;
